import { VStack } from "@chakra-ui/react"
import React from "react"
import { CreateUserForm } from "../../forms"

export const CreateUser: React.FC = () => {
	return (
		<VStack w="full" maxW="sm" spacing={6}>
			<CreateUserForm />
		</VStack>
	)
}
